import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';

class ObservaleQueue {
	q = [];
	
	push(o$) {
		let me = this;
		
		return Observable.create(function (observer) {
			let index = me.q.length - 1;
			me.q.push(
				o$.subscribe(
					(d) => {
						observer.next(d);
					},
					err => {
						observer.error(err);
					},
					() => {
						me.q.splice(index, 1);
						observer.complete();
					}
				)
			);
		});
	}
	
	
	reset() {
		for (let o2$ of this.q) {
			o2$.unsubscribe();
		}
		
		this.q = [];
	}
}


export class BaseService {
	q$;
	
	constructor(
		public http: HttpClient,
	) {
		this.q$ = new ObservaleQueue();
	}
}
